// Containers
import Full from '@/containers/Full'
import EditConfigs from '@/views/configs/Edit'
// Views
import Dashboard from '@/views/Dashboard'
import ListFlights from '@/views/flights/List'
import FlightStore from '@/views/flights/Store'
import EditGuest from '@/views/guests/Edit'
import Login from '@/views/pages/Login'
import Page404 from '@/views/pages/Page404'
import Page500 from '@/views/pages/Page500'
import EditParticipant from '@/views/participants/Edit'
import ListParticipants from '@/views/participants/List'
import Vue from 'vue'
import Router from 'vue-router'
import Store from './../store'




Vue.use(Router)

const router = new Router({
  mode: 'hash',
  linkActiveClass: 'open active',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/',
      redirect: '/dashboard',
      name: 'Home',
      component: Full,
      children: [
        {
          path: 'dashboard',
          name: 'Dashboard',
          component: Dashboard
        },
        {
          path: 'participantes/:updated?',
          name: 'Participantes',
          component: ListParticipants
        },
        {
          path: 'participante/:id/:guests?/:updatedGuest?',
          name: 'Participante',
          component: EditParticipant
        },
        {
          path: 'acompanhante/:id',
          name: 'Acompanhante',
          component: EditGuest
        },
        {
          path: 'voos',
          name: 'Voos',
          component: ListFlights
        },
        {
          path: 'voos/create',
          name: 'Manutenção de voo',
          component: FlightStore
        },
        {
          path: 'voos/create/:id',
          name: 'Editar voo',
          component: FlightStore
        },
        {
          path: 'configs/edit',
          name: 'Configurações',
          component: EditConfigs
        }
      ]
    },
    {
      path: '*',
      redirect: '/default/404',
      name: 'Pages',
      component: {
        render (c) { return c('router-view') }
      },
      children: [
        {
          path: '404',
          name: 'Page404',
          component: Page404
        },
        {
          path: '500',
          name: 'Page500',
          component: Page500
        },
        {
          path: 'login',
          name: 'Login',
          component: Login
        }
      ]
    }
  ]
})

router.beforeEach((to, from, next) => {
  if ((to.name !== 'Login') && (Store.state.token === null || Store.state.token === 'null')) {
    next({name: 'Login'})
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js